<template>
  <v-layout>
    <v-flex xs12 sm10 md8 class="form-container">
      <v-layout wrap>
        <v-flex xs12>
          <div v-if="$apollo.loading">
            <spinner />
          </div>
          <form v-else v-scroll-to-error @submit.prevent="submitForm">
            <div class="screen-title mb-32">
              <span>{{ adminText('workflowsAll.update_hall_03a6368', 'Update hall') }}</span>
            </div>
            <hall-form
              :vs="$v"
              :initial-values="form"
              :event-id="eventId"
              @values="form=$event"
            />
            <main-button
              :text="adminText('workflowsAll.update_fb91e24', 'Update')"
              depressed
              @click="$emit('submit')"
            />
            <main-button
              :text="adminText('workflowsAll.delete_f6fdbe4', 'Delete')"
              color="error"
              flat
              @click.prevent="showDeleteDialog = true"
            />
            <main-button :text="adminText('workflowsAll.cancel_77dfd21', 'Cancel')" flat @click.prevent="goBack" />
          </form>
        </v-flex>
      </v-layout>
    </v-flex>
    <delete-dialog
      :content="workflowLabel((adminText('workflowsAll.are_you_sure_you_want_to_delete_this_hall_thi_713d48d', 'Are you sure you want to delete this hall? This operation cannot be undone.')))"
      :on-delete="() => deleteHall()"
      :show.sync="showDeleteDialog"
      :title="adminText('workflowsAll.remove_hall_6130ffc', 'Remove hall')"
    />
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { GET_EVENT_HALL } from '../../graphql/halls.graphql.js'
import DeleteDialog from './../shared/dialogs/delete-dialog.vue'
import HallForm from './hall-form.vue'
import MainButton from './../shared/main-button'
import Spinner from './../shared/spinner'
import { deleteHall, updateHall } from './../../http'
import { required } from 'vuelidate/lib/validators'
import { submitGuard } from './../../utils'


export default {
  mixins: [WorkflowDisplay],
  name: 'update-hall-container',
  components: {
    HallForm,
    MainButton,
    Spinner,
    DeleteDialog,
  },
  props: {
    eventId: {
      default: null,
      type: String,
    },
    hallId: {
      default: null,
      type: String,
    },
  },
  validations() {
    return {
      form: {
        name: { required },
      },
    }
  },
  data: () => ({
    showDeleteDialog: false,
    form: {},
  }),
  apollo: {
    getEventHall: {
      query: GET_EVENT_HALL,
      variables() {
        return {
          eventId: this.eventId,
          hallId: this.hallId,
        }
      },
      manual: true,
      result({ loading, data }) {
        if (!loading) {
          const { getHall: hall} = data
          this.form = hall
        }
      },
    },
  },
  methods:{
    async deleteHall() {
      await deleteHall({hallId: this.hallId})
      this.goBack()
    },
    async submitForm() {
      await submitGuard(this, async () =>{
        await updateHall({
          hallId: this.hallId,
          input: {
            name: this.form.name,
            color: this.form.color,
            image: this.form.image,
          },
        })
        this.goBack()
      })
    },
  },
}
</script>

<style>
.form-container {
  margin-right: 30px;
}
.workshop-details {
  margin: 68px -30px 0 0;
}
</style>
